// A full rail plus a readable control page needs more room than a tablet.
// Below this breakpoint the same links move into a horizontal, scrollable
// navigation row so every Control route remains reachable without shrinking
// the content into a narrow rail.
export const CONTROL_DESKTOP_BREAKPOINT = 1200;

export function controlNavigationMode(width: number): "compact" | "desktop" {
  return width >= CONTROL_DESKTOP_BREAKPOINT ? "desktop" : "compact";
}
